module.exports = "img/flags/BB.c7a0d2e.png";